import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'
import type { BillingPaymentCard } from './billing.interface'
import { BillingPaymentCardItem } from './billing-payment-card-item.molecule'

export interface BillingPaymentMethodsSectionProps {
  cardList: BillingPaymentCard[]
  onSetDefault?: (card: BillingPaymentCard) => void
  onDeleteCard?: (card: BillingPaymentCard) => void
  className?: string
}

const BillingPaymentMethodsSectionBase: React.FC<BillingPaymentMethodsSectionProps> = ({
  cardList,
  onSetDefault,
  onDeleteCard,
  className,
}): ReactNode => {
  const isOnlyCard = cardList.length === 1

  return (
    <div className={cn('billing-payment-methods-section', className)}>
      {cardList.length === 0 ? (
        <p className="text-center text-muted-foreground py-6">No payment methods added yet.</p>
      ) : (
        <div className="space-y-3">
          {cardList.map((card) => (
            <BillingPaymentCardItem
              key={card.id}
              card={card}
              isOnlyCard={isOnlyCard}
              onSetDefault={onSetDefault}
              onDelete={onDeleteCard}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export const BillingPaymentMethodsSection = memo(BillingPaymentMethodsSectionBase)

BillingPaymentMethodsSection.displayName = 'BillingPaymentMethodsSection'
